export default __webpack_public_path__ + "static/media/img2.0b3a46c2.jpg";